import { createContext } from "react";

export const BetBuilderModeContext = createContext<true | false>(false);
